import React from 'react';
import { useDeviceType } from '../../hooks/useDeviceType';
import '../../styles/components/ResponsiveContainer.css';

interface ResponsiveContainerProps {
  children: React.ReactNode;
  className?: string;
  fluid?: boolean;
}

/**
 * ResponsiveContainer - Container component with responsive width constraints
 * Uses Bootstrap-inspired responsive behavior with custom breakpoints
 */
export const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({
  children,
  className = '',
  fluid = false
}) => {
  const { deviceType } = useDeviceType();
  
  // Add device-specific class for additional styling if needed
  const deviceClass = `responsive-container-${deviceType}`;
  
  // If fluid is true, the container will take full width of its parent
  const fluidClass = fluid ? 'responsive-container-fluid' : '';
  
  return (
    <div className={`responsive-container ${deviceClass} ${fluidClass} ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveContainer;
